import React, { PureComponent } from 'react'

export default class Alert extends PureComponent {
  render() {
    if (this.props.active) {
      return (
        <div
          className={`alert alert-${
            this.props.type
          } notification animated fade-in fade-out`}
          role="alert"
        >
          {this.props.message}
        </div>
      )
    }
    return null
  }
}

Alert.defaultProps = {
  type: 'success'
}



// WEBPACK FOOTER //
// ./src/views/Widgets/Alert.js